import NewAppBar from "components/Navbars/AppBar";
import React, { useEffect, useState } from "react";

import SearchBar from "./SearchBar";
import ListPosts from "./ListPosts";
import { Box, Dialog } from "@mui/material";
import Footer from "views/Landing/Footer";
import Details from "./Details";
import usePostsWithPagination from "hooks/usePostsWithPagination";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

function OffersPage() {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [location, setLocation] = useState("");
  const [mode, setMode] = useState("");
  const [type, setType] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const jobsLocation = useLocation();
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };
  const { t } = useTranslation();

  const {
    handleSearch,
    posts,
    loading,
    error,
    pagination,
    goToNextPage,
    goToPreviousPage,
    goToPage,
    refreshPosts,
  } = usePostsWithPagination({
    searchTerm,
    location,
    showSnackbar,
    setSearchTerm,
    setLocation,
    t,
    type,
    mode,
  });

  // Extract search parameters from URL state
  useEffect(() => {
    // Only run this effect once when the component mounts or when location state changes
    if (jobsLocation && jobsLocation.state) {
      const {
        search: searchParam,
        location: locationParam,
        mode: modeParam,
        type: typeParam
      } = jobsLocation.state;

      console.log('Navigation params =>:', { searchParam, locationParam, modeParam, typeParam });

      // Set values only once when the component mounts with state
      setSearchTerm(searchParam || '');
      setLocation(locationParam || '');
      setMode(modeParam || '');
      setType(typeParam || '');
    }
  // Only depend on jobsLocation, not on searchTerm, location, or handleSearch
  }, []);
  
  // Separate effect to handle the search
  useEffect(() => {
    // Skip on initial render
    const shouldSearch = searchTerm || location || mode || type;
    if (shouldSearch) {
      // Use a ref to track if this is the first render
      const timer = setTimeout(() => {
        handleSearch({ preventDefault: () => {} });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleJobClick = (job) => {
    setSelectedJob(job);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedJob(null);
  };
  
  return (
    <Box>
      <NewAppBar />

      <Box
        sx={{
          marginLeft: { md: "60px", xs: "0" },
        }}
      >
        <SearchBar
          searchTerm={searchTerm}
          location={location}
          showSnackbar={showSnackbar}
          t={t}
          handleSearch={handleSearch}
          setLocation={setLocation}
          setSearchTerm={setSearchTerm}
          setType={setType}
          setMode={setMode}
          mode={mode}
          type={type}
        />
        <ListPosts
          setSelectedJob={setSelectedJob}
          setOpenDialog={setOpenDialog}
          posts={posts}
          loading={loading}
          error={error}
          pagination={pagination}
          goToNextPage={goToNextPage}
          goToPreviousPage={goToPreviousPage}
          goToPage={goToPage}
          refreshPosts={refreshPosts}
        />
      </Box>
      <Footer />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth={false}
        PaperProps={{
          style: {
            position: "fixed",
            bottom: 0,
            width: "100%",
            margin: 0,
            borderRadius: 0,
            borderTopLeftRadius: "40px",
            borderTopRightRadius: "40px",
            height: "85vh",
            maxWidth: "none",
            overflowY: "auto",
            left: 0,
            right: 0,
            boxSizing: "border-box",
            // Scrollbar styling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "transparent transparent", // For Firefox
          },
        }}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.5)",
          },
        }}
      >
        <Details 
          job={selectedJob} 
          posts={posts} 
          onClose={handleCloseDialog}
          setSelectedJob={setSelectedJob}
          setOpenDialog={setOpenDialog}
          refresh={refreshPosts}
        />
      </Dialog>
    </Box>
  );
}

export default OffersPage;